export function formatRegistrationNumber(input: string) {
  if (!input) return "";

  const clean = input.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

  // ---- BH series ----
  const bhMatch = clean.match(/^(\d{2})(BH)(\d{4})([A-Z]{2})$/);
  if (bhMatch) {
    const [, year, bh, number, series] = bhMatch;
    return `${year}${bh}-${number}-${series}`;
  }

  // ---- Normal Indian series ----
  const normalMatch = clean.match(/^([A-Z]{2})(\d{1,2})([A-Z]{1,2})(\d{4})$/);
  if (normalMatch) {
    const [, state, district, series, number] = normalMatch;
    return `${state}${district}-${series}-${number}`;
  }
}


export const sanitizeRegistrationNumber = (value: string) =>
  value.toUpperCase().replace(/[^A-Z0-9]/g, "");

const CAR_VALUATION_WIDGET_REGEXPS = [
  /^[A-Z]{2}[0-9]{2}[A-Z]{2}(?!0000$)[0-9]{4}$/,
  /^[A-Z]{2}[0-9]{2}[A-Z][0-9]{4}$/,
  /^[A-Z]{3}[0-9]{4}$/,
  /^[A-Z]{2}[0-9]{2}[A-Z]{3}[0-9]{4}$/,
  /^[A-Z]{2}(?!000000$)[0-9]{6}$/,
  /^[A-Z]{2}[0-9]{3}[A-Z][0-9]{4}$/,
  /^[A-Z]{2}[0-9]{4}[A-Z][0-9]{4}$/,
  /^[A-Z]{2}[0-9]{3}[A-Z]{2}[0-9]{4}$/,
  /^[A-Z]{2}[0-9]{2}[A-Z][1-9][0-9]{4}$/,
  /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{5}$/,
  /^[A-Z]{2}[0-9]{2}[A-Z][0-9]{6}$/,

  /^(GJ|DL|BR)[0-9][A-Z]{2}[0-9]{4}$/,
  /^(GJ|DL|BR)[0-9][A-Z][0-9]{4}$/,
  /^(GJ|DL|BR)[0-9][A-Z]{3}[0-9]{4}$/,
  /^(GJ|DL|BR)[0-9]{5}$/,
  /^(GJ|DL|BR)[0-9][A-Z][0-9]{5}$/,
  /^(GJ|DL|BR)[0-9][A-Z]{2}[0-9]{5}$/,
  /^(GJ|DL|BR)[0-9][A-Z][0-9]{6}$/,

  /^[0-9]{2}[A-Z]{2}[0-9]{2}$/,
  /^[0-9]{2}[A-Z]{2}[0-9]{3}$/,
  /^[0-9]{2}[A-Z][0-9]{4}$/,
  /^[0-9]{2}[A-Z]{2}[0-9]{4}$/,
  /^[0-9]{2}[A-Z]{2}[0-9]{4}[A-Z]$/,
  /^[0-9]{2}[A-Z]{2}[0-9]{4}[A-Z]{2}$/,
];

export const registrationNumberValidator = (value: string) => {
  const normalizedValue = sanitizeRegistrationNumber(value);

  return CAR_VALUATION_WIDGET_REGEXPS.some((regexp) =>
    regexp.test(normalizedValue)
  );
};